import React from "react"

// import { useTranslation } from "react-i18next"
import { useApiContext } from "~/api"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
// import { ContactForm } from "~/components/ContactForm/ContactForm"
import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"
// import { ContentBlueForm } from "./components/ContentBlueForm/ContentBlueForm"

const СalendarEvent: React.FC = () => {
  const content = useApiContext("/calendar/element")
  // const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={content.name}>
      <div className="container">
        <Breadcrumbs />

        <Content />
      </div>

      {/* <ContactForm
        content={() => <ContentBlueForm />}
        title={t("calendarEvent.BlueForm.Title")}
        showMobileText
      /> */}
    </Layout>
  )
}

export default СalendarEvent
